import * as paths from 'src/app/router/paths';
import { getUrlPathWithPreservedQuery } from 'src/app/utils';

import { CopyrightLink, LegalLinksContainer } from './styles';

export const LegalLinks = () => (
  <LegalLinksContainer>
    <CopyrightLink to={getUrlPathWithPreservedQuery(paths.termsAndConditions.toPath())} target={'_blank'}>
      Terms of Service
    </CopyrightLink>
    <CopyrightLink to={getUrlPathWithPreservedQuery(paths.privacy.toPath())} target={'_blank'}>
      Privacy Policy
    </CopyrightLink>
    <CopyrightLink to={getUrlPathWithPreservedQuery(paths.hipaa.toPath())} target={'_blank'}>
      HIPAA Policy
    </CopyrightLink>
  </LegalLinksContainer>
);
